module.exports = __webpack_public_path__ + "static/media/s_26.87666581.mp3";